import React, { Component, PropTypes } from 'react';
import blacklist from 'blacklist';
import classNames from 'classnames';

import './CheckboxControl.scss';

class CheckboxControl extends Component {

    static propTypes = {
        label: PropTypes.any,
        subLabel: PropTypes.string,
        value: PropTypes.bool,
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        stopClickCheckboxPropagation: PropTypes.bool,
    }

    static defaultProps = {
        label: '',
        subLabel: '',
        disabled: false,
        value: false,
        name: '',
        stopClickCheckboxPropagation: false,
    }

    state = {
        value: this.props.value
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.props.value) {
            this.setState({ value: newProps.value });
        }
    }

    _onChange = (event) => {
        if (this.props.onChange) {
            this.props.onChange(event, event.target.checked);
        }
    }

    _toggleValue = (event) => {
        if (this.props.stopClickCheckboxPropagation) {
            event.stopPropagation();
        }

        if (this.props.onClick) {
            this.props.onClick(event);
        }

        // Prevent out of sync browser and react state
        if (event.isDefaultPrevented()) {
            return false;
        }

        this.setState({ value: !this.state.value });
    }

    render() {
        let isDisabled = false;

        if (this.props.label) {
            if (this.props.label === 'Блиц-перевод') {
                isDisabled = true;
            }

            var label = (
                <span className="CheckboxControl-label">
                    {this.props.label}
                </span>
            );

            if (this.props.subLabel) {
                label = (
                    <span className="CheckboxControl-label -sublabled">
                        {this.props.label}
                        <br />
                        <span className="CheckboxControl-sublabel">
                            {this.props.subLabel}
                        </span>
                    </span>
                );
            }
        }

        var props = blacklist(this.props, 'stopClickCheckboxPropagation', 'attribute', 'error', 'subLabel');

        return (
            <label className={classNames([
                'CheckboxControl',
                this.props.className
            ])}>
                <input {...props}
                    className="CheckboxControl-input"
                    type="checkbox"
                    onChange={this._onChange}
                    onClick={this._toggleValue}
                    checked={this.state.value}
                    disabled={isDisabled || this.props.disabled}
                    name={this.props.name} />
                <div className="CheckboxControl-box" />
                {label}
            </label>
        );
    }

}

export default CheckboxControl;



// WEBPACK FOOTER //
// ./client/components/CheckboxControl/CheckboxControl.js